<template>
    <modal name="first-login-3" :classes="[
        'v--modal',
        'error-modal',
        'first-login',
        'first-login-3',
        hasBugs && 'has-bugs',
    ]" @before-open="beforeOpen" @before-close="beforeClose" :width="458" :height="'auto'" :scrollable="true"
        :adaptive="true">
        <div class="modal-title">{{ $t("firstLogin.fillForm") }}</div>
        <div class="modal-body">
            <div class="first-login-image"></div>

            <div class="form-group multiselect-group">
                <label class="label"></label>
                <multiselect v-model="localUser.show_birthday" :options="optionsConstructor('show_birthday')"
                    :searchable="false" :placeholder="$t('profileEdit.showDateBirth')"
                    :custom-label="(opt) => customShowBirthdayLabel(opt)" selectLabel="" deselectLabel=""
                    :option-height="26" :allowEmpty="false" openDirection="bottom" id="show_birthday" name="show_birthday"
                    class="multiselect-select" :class="{ 'multiselect-error': errors.has('show_birthday') }">
                </multiselect>
            </div>

            <div class="form-group">
                <label for="city" class="label">{{ $t("search.city") }}:</label>
                <input type="text" id="city" v-model="localUser.city" @input="updated($event)" @change="updated($event)"
                    :maxlength="150" name="city" class="input" />
            </div>

            <div class="form-group multiselect-group">
                <label for="education" class="label">
                    {{ $t("profileEdit.education") }}
                    :</label>
                <multiselect v-model="localUser.education" :options="optionsConstructor('education')" :searchable="false"
                    :placeholder="$t('profileEdit.education')" :custom-label="(opt) => customEducationLabel(opt)"
                    selectLabel="" deselectLabel="" :option-height="26" :allowEmpty="false" openDirection="bottom"
                    id="education" name="education" class="multiselect-select"
                    :class="{ 'multiselect-error': errors.has('education') }"></multiselect>
            </div>

            <div class="form-group multiselect-group">
                <label for="height" class="label">
                    {{ $t("profileEdit.height") }}
                    :</label>
                <multiselect v-model="localUser.height" :options="optionsConstructor('height')" :searchable="false"
                    :placeholder="$t('profileEdit.height')" :custom-label="(opt) => customHeightLabel(opt)" selectLabel=""
                    deselectLabel="" :option-height="26" :allowEmpty="false" openDirection="bottom" id="height"
                    name="height" class="multiselect-select" :class="{ 'multiselect-error': errors.has('height') }">
                </multiselect>
            </div>

            <div class="form-group multiselect-group">
                <label for="weight" class="label">
                    {{ $t("profileEdit.weight") }}
                    :</label>
                <multiselect v-model="localUser.weight" :options="optionsConstructor('weight')" :searchable="false"
                    :placeholder="$t('profileEdit.weight')" :custom-label="(opt) => customWeightLabel(opt)" selectLabel=""
                    deselectLabel="" :option-height="26" :allowEmpty="false" openDirection="bottom" id="weight"
                    name="weight" class="multiselect-select" :class="{ 'multiselect-error': errors.has('weight') }">
                </multiselect>
            </div>

            <div class="form-group multiselect-group">
                <label for="body_type" class="label">
                    {{ $t("profile.bodyImage") }}
                    :</label>
                <multiselect v-model="localUser.body_type" :options="optionsConstructor('body_type')" :searchable="false"
                    :placeholder="$t('profileEdit.body_type')" :custom-label="(opt) => customBodytypeLabel(opt)"
                    selectLabel="" deselectLabel="" :option-height="26" :allowEmpty="false" openDirection="bottom"
                    id="body_type" name="body_type" class="multiselect-select"
                    :class="{ 'multiselect-error': errors.has('body_type') }"></multiselect>
            </div>

            <div class="form-group multiselect-group">
                <label for="family_status" class="label">
                    {{ $t("profile.maritalStatus") }}
                    :</label>
                <multiselect v-model="localUser.family_status" :options="optionsConstructor('family_status')"
                    :searchable="false" :placeholder="$t('profileEdit.family_status')"
                    :custom-label="(opt) => customFamilyLabel(opt)" selectLabel="" deselectLabel="" :option-height="26"
                    :allowEmpty="false" openDirection="bottom" id="family_status" name="family_status"
                    class="multiselect-select" :class="{ 'multiselect-error': errors.has('family_status') }"></multiselect>
            </div>

            <div class="form-group multiselect-group">
                <label for="amount_of_children" class="label">
                    {{ $t("profileEdit.children") }}
                    :</label>
                <multiselect v-model="localUser.amount_of_children" :options="optionsConstructor('amount_of_children')"
                    :searchable="false" :placeholder="$t('profileEdit.amount_of_children')"
                    :custom-label="(opt) => customChildrenLabel(opt)" selectLabel="" deselectLabel="" :option-height="26"
                    :allowEmpty="false" openDirection="bottom" id="amount_of_children" name="amount_of_children"
                    class="multiselect-select" :class="{ 'multiselect-error': errors.has('amount_of_children') }">
                </multiselect>
            </div>

            <div class="form-group multiselect-group">
                <label for="acquaintance_goal" class="label">
                    {{ $t("profile.purposeDating") }}
                    :</label>
                <multiselect v-model="localUser.acquaintance_goal" :options="optionsConstructor('acquaintance_goal')"
                    :searchable="false" :placeholder="$t('profileEdit.amount_of_children')"
                    :custom-label="(opt) => customAcquaintanceLabel(opt)" selectLabel="" deselectLabel=""
                    :option-height="26" :allowEmpty="false" openDirection="bottom" id="acquaintance_goal"
                    name="acquaintance_goal" class="multiselect-select"
                    :class="{ 'multiselect-error': errors.has('acquaintance_goal') }"></multiselect>
            </div>

            <div class="form-group multiselect-group">
                <label for="smoking" class="label">
                    {{ $t("profile.smoking") }}
                    :</label>
                <multiselect v-model="localUser.smoking" :options="optionsConstructor('smoking')" :searchable="false"
                    :placeholder="$t('profileEdit.smoking')" :custom-label="(opt) => customSmokingLabel(opt)" selectLabel=""
                    deselectLabel="" :option-height="26" :allowEmpty="false" openDirection="bottom" id="smoking"
                    name="smoking" class="multiselect-select" :class="{ 'multiselect-error': errors.has('smoking') }">
                </multiselect>
            </div>

            <div class="form-group multiselect-group">
                <label for="alcohol" class="label">
                    {{ $t("profile.alcohol") }}
                    :</label>
                <multiselect v-model="localUser.alcohol" :options="optionsConstructor('alcohol')" :searchable="false"
                    :placeholder="$t('profileEdit.alcohol')" :custom-label="(opt) => customAlcoholLabel(opt)" selectLabel=""
                    deselectLabel="" :option-height="26" :allowEmpty="false" openDirection="bottom" id="alcohol"
                    name="alcohol" class="multiselect-select" :class="{ 'multiselect-error': errors.has('alcohol') }">
                </multiselect>
            </div>

            <div class="form-group multiselect-group languages-group">
                <label for="languages" class="label">
                    {{ $t("profileEdit.knowledgeLanguages") }}:</label>
                <multiselect v-model="localUser.languages" :options="languagesOptions" :multiple="true" :searchable="true"
                    placeholder="" :custom-label="(opt) => customLanguagesLabel(opt)" selectLabel="" deselectLabel=""
                    :option-height="26" :allowEmpty="true" :taggable="true" :hideSelected="true" openDirection="bottom"
                    id="languages" class="multiselect-select multiselect-multiple"></multiselect>
            </div>

            <div class="form-group textarea-group">
                <label for="about" class="label">{{ $t("profile.aboutMyself") }}:</label>
                <textarea v-model="localUser.about" @input="updated($event)" @change="updated($event)" :maxlength="255"
                    id="about" class="textarea"></textarea>
            </div>
            <div class="form-bottom buttons-center">
                <button @click="next" class="button">{{ $t("firstLogin.next") }}</button>
                <button v-if="loader" class="button-loader"></button>
                <br />
                <span @click="next" class="link">{{ $t("firstLogin.skipStep") }}</span>
            </div>
        </div>
    </modal>
</template>

<script>
import { mapGetters } from "vuex";
import { consts } from "@/consts";
import { localizeValidation } from "@/mixins/localizeValidation";
import { updateForm } from "@/mixins/updateForm";
import { saveProfile } from "@/mixins/saveProfile";
import Multiselect from "@/components/Blocks/Multiselect";
import { checkScroll } from "@/mixins/checkScroll";

export default {
    name: "FirstLogin3",
    props: {
        i18n: Object,
    },
    components: { Multiselect },
    mixins: [localizeValidation, updateForm, saveProfile, checkScroll],
    data() {
        return {
            loader: false,
            hasBugs: false,
            tempUser: {},
            consts: consts,
            languagesOptions: [],
            profileParams: [
                { key: "education", label: this.$t("profile.education") },
                { key: "height", label: this.$t("profile.growth") },
                { key: "weight", label: this.$t("profile.weight") },
                { key: "body_type", label: this.$t("profile.bodyImage") },
                { key: "family_status", label: this.$t("profile.maritalStatus") },
                { key: "amount_of_children", label: this.$t("profile.children") },
                { key: "acquaintance_goal", label: this.$t("profile.purposeDating") },
                { key: "smoking", label: this.$t("profile.smoking") },
                { key: "alcohol", label: this.$t("profile.alcohol") },
            ],
            show_birthday: [
                { 'value': 0, 'text': this.$t('firstLogin.birthdayNoShow') },
                { 'value': 1, 'text': this.$t('firstLogin.birthdayShow') },
                { 'value': 2, 'text': this.$t('firstLogin.birthdayNoShowYear') }
            ],
            education: [
                { value: "0", text: this.$t('profileEdit.notSelected') },
                { value: "1", text: this.$t('profileEdit.average') },
                { value: "2", text: this.$t('profileEdit.secondarySpecialised') },
                { value: "3", text: this.$t('profileEdit.incompleteHigherEducation') },
                { value: "4", text: this.$t('profileEdit.higherEducation') },
                { value: "5", text: this.$t('profileEdit.twoMoreUniversity') },
            ],
            height: [
                { value: "0", text: this.$t('profileEdit.notSelected') },
                { value: "1", text: this.$t('profileEdit.low') },
                { value: "2", text: this.$t('profileEdit.belowAverage') },
                { value: "3", text: this.$t('profileEdit.medium') },
                { value: "4", text: this.$t('profileEdit.aboveAverage') },
                { value: "5", text: this.$t('profileEdit.high') },
            ],
            weight: [
                { value: "0", text: this.$t('profileEdit.notSelected') },
                { value: "1", text: this.$t('profileEdit.weight40') },
                { value: "2", text: this.$t('profileEdit.weight4050') },
                { value: "3", text: this.$t('profileEdit.weight5060') },
                { value: "4", text: this.$t('profileEdit.weight6070') },
                { value: "5", text: this.$t('profileEdit.weight7080') },
                { value: "6", text: this.$t('profileEdit.weight8090') },
                { value: "7", text: this.$t('profileEdit.weight90100') },
                { value: "8", text: this.$t('profileEdit.weight100110') },
                { value: "9", text: this.$t('profileEdit.weight110120') },
                { value: "10", text: this.$t('profileEdit.weight120130') },
                { value: "11", text: this.$t('profileEdit.weight130140') },
                { value: "12", text: this.$t('profileEdit.weight140150') },
                { value: "13", text: this.$t('profileEdit.weight150') },
            ],
            family_status: [
                { value: "0", text: this.$t('profileEdit.notSelected') },
                { value: "1", text: this.$t('profileEdit.singleUnmarried') },
                { value: "2", text: this.$t('profileEdit.dating') },
                { value: "3", text: this.$t('profileEdit.engaged') },
                { value: "4", text: this.$t('profileEdit.married') },
                { value: "5", text: this.$t('profileEdit.commonMarriage') },
                { value: "6", text: this.$t('profileEdit.inLove') },
                { value: "7", text: this.$t('profileEdit.itComplicated') },
            ],
            body_type: [
                { value: "0", text: this.$t('profileEdit.notSelected') },
                { value: "1", text: this.$t('profileEdit.skinny') },
                { value: "2", text: this.$t('profileEdit.ordinary') },
                { value: "3", text: this.$t('profileEdit.athletic') },
                { value: "4", text: this.$t('profileEdit.muscular') },
                { value: "5", text: this.$t('profileEdit.dense') },
                { value: "6", text: this.$t('profileEdit.complete') },
            ],
            amount_of_children: [
                { value: "0", text: this.$t('profileEdit.notSelected') },
                { value: "1", text: this.$t('profileEdit.childrenNot') },
                { value: "2", text: this.$t('profileEdit.childrenOne') },
                { value: "3", text: this.$t('profileEdit.childrenTwo') },
                { value: "4", text: this.$t('profileEdit.childrenThree') },
                { value: "5", text: this.$t('profileEdit.childrenMoreFour') },
            ],
            acquaintance_goal: [
                { value: "0", text: this.$t('profileEdit.notSelected') },
                { value: "1", text: this.$t('profileEdit.friendship') },
                { value: "2", text: this.$t('profileEdit.correspondence') },
                { value: "3", text: this.$t('profileEdit.relationship') },
                { value: "4", text: this.$t('profileEdit.flirting') },
                { value: "5", text: this.$t('profileEdit.marriage') },
                { value: "6", text: this.$t('profileEdit.coOperativePlay') },
            ],
            smoking: [
                { value: "0", text: this.$t('profileEdit.notSelected') },
                { value: "1", text: this.$t('profileEdit.smokingNot') },
                { value: "2", text: this.$t('profileEdit.smokingAlmost') },
                { value: "3", text: this.$t('profileEdit.smokingQuitting') },
                { value: "4", text: this.$t('profileEdit.smokingSmoke') },
            ],
            alcohol: [
                { value: "0", text: this.$t('profileEdit.notSelected') },
                { value: "1", text: this.$t('profileEdit.alcoholNot') },
                { value: "2", text: this.$t('profileEdit.alcoholCompany') },
                { value: "3", text: this.$t('profileEdit.alcoholLike') },
            ],
            languages: [
                this.$t('profileEdit.Abazin'),
                this.$t('profileEdit.Abenaki'),
                this.$t('profileEdit.Abkhaz'),
                this.$t('profileEdit.Avar'),
                this.$t('profileEdit.Avestan'),
                this.$t('profileEdit.Avango'),
                this.$t('profileEdit.Agul'),
                this.$t('profileEdit.Adyghe'),
                this.$t('profileEdit.Azerbaijani'),
                this.$t('profileEdit.Aymara'),
                this.$t('profileEdit.Ayni'),
                this.$t('profileEdit.Ainu'),
                this.$t('profileEdit.Akan'),
                this.$t('profileEdit.Akkadian'),
                this.$t('profileEdit.Alabama'),
                this.$t('profileEdit.Albanian'),
                this.$t('profileEdit.Aleut'),
                this.$t('profileEdit.Algerian'),
                this.$t('profileEdit.Altai'),
                this.$t('profileEdit.Amaliri'),
                this.$t('profileEdit.Amis'),
                this.$t('profileEdit.Amharic'),
                this.$t('profileEdit.English'),
                this.$t('profileEdit.AngloSaxon'),
                this.$t('profileEdit.Andi'),
                this.$t('profileEdit.Anuta'),
                this.$t('profileEdit.Apache'),
                this.$t('profileEdit.Arabela'),
                this.$t('profileEdit.Arabic'),
                this.$t('profileEdit.Aragonese'),
                this.$t('profileEdit.Aramaic'),
                this.$t('profileEdit.Aranese'),
                this.$t('profileEdit.Arantha'),
                this.$t('profileEdit.Arapaho'),
                this.$t('profileEdit.Argobba'),
                this.$t('profileEdit.Armenian'),
                this.$t('profileEdit.Arnaut'),
                this.$t('profileEdit.Aromanian'),
                this.$t('profileEdit.Archi'),
                this.$t('profileEdit.Assamese'),
                this.$t('profileEdit.Asturian'),
                this.$t('profileEdit.Atayal'),
                this.$t('profileEdit.Afar'),
                this.$t('profileEdit.Afrikaans'),
                this.$t('profileEdit.Ahom'),
                this.$t('profileEdit.Bagata'),
                this.$t('profileEdit.Bagvalal'),
                this.$t('profileEdit.Balinese'),
                this.$t('profileEdit.Bambara'),
                this.$t('profileEdit.Baniwa'),
                this.$t('profileEdit.Bantawa'),
                this.$t('profileEdit.Basque'),
                this.$t('profileEdit.Bassa'),
                this.$t('profileEdit.BahasaSinama'),
                this.$t('profileEdit.Bashkir'),
                this.$t('profileEdit.Bedja'),
                this.$t('profileEdit.Belarusian'),
                this.$t('profileEdit.Balochi'),
                this.$t('profileEdit.Bemba'),
                this.$t('profileEdit.Benkha'),
                this.$t('profileEdit.Bikol'),
                this.$t('profileEdit.Bislama'),
                this.$t('profileEdit.Blackfoot'),
                this.$t('profileEdit.Bulgarian'),
                this.$t('profileEdit.Bora'),
                this.$t('profileEdit.Bosnian'),
                this.$t('profileEdit.Breton'),
                this.$t('profileEdit.Budukh'),
                this.$t('profileEdit.Buruwai'),
                this.$t('profileEdit.Buryat'),
                this.$t('profileEdit.Bhutanese'),
                this.$t('profileEdit.Bugis'),
                this.$t('profileEdit.Bhojpuri'),
                this.$t('profileEdit.Vai'),
                this.$t('profileEdit.Wayampi'),
                this.$t('profileEdit.Welsh'),
                this.$t('profileEdit.Walloon'),
                this.$t('profileEdit.Warlpiri'),
                this.$t('profileEdit.Wakhi'),
                this.$t('profileEdit.Wend'),
                this.$t('profileEdit.Venetian'),
                this.$t('profileEdit.Veps'),
                this.$t('profileEdit.VikMungkan'),
                this.$t('profileEdit.Viraraturi'),
                this.$t('profileEdit.Votic'),
                this.$t('profileEdit.Volapuk'),
                this.$t('profileEdit.Võro'),
                this.$t('profileEdit.Vietnamese'),
                this.$t('profileEdit.Greek'),
                this.$t('profileEdit.Georgian'),
                this.$t('profileEdit.Waorani'),
                this.$t('profileEdit.Dari'),
                this.$t('profileEdit.Danish'),
                this.$t('profileEdit.Jersey'),
                this.$t('profileEdit.Dinka'),
                this.$t('profileEdit.Doluo'),
                this.$t('profileEdit.Duala'),
                this.$t('profileEdit.Dusun'),
                this.$t('profileEdit.EgyptianArabic'),
                this.$t('profileEdit.WestFrisian'),
                this.$t('profileEdit.Iban'),
                this.$t('profileEdit.Hebrew'),
                this.$t('profileEdit.Izhora'),
                this.$t('profileEdit.Ilokano'),
                this.$t('profileEdit.Ingush'),
                this.$t('profileEdit.Indonesian'),
                this.$t('profileEdit.Irish'),
                this.$t('profileEdit.Icelandic'),
                this.$t('profileEdit.Spanish'),
                this.$t('profileEdit.Italian'),
                this.$t('profileEdit.Kabardian'),
                this.$t('profileEdit.Kabyle'),
                this.$t('profileEdit.Kabuverdianu'),
                this.$t('profileEdit.Kaingang'),
                this.$t('profileEdit.Cayuga'),
                this.$t('profileEdit.Kalmyk'),
                this.$t('profileEdit.Kanuri'),
                this.$t('profileEdit.Kapampangan'),
                this.$t('profileEdit.Karaite'),
                this.$t('profileEdit.Karakalpak'),
                this.$t('profileEdit.Karamojong'),
                this.$t('profileEdit.KarachayBalkar'),
                this.$t('profileEdit.Karelian'),
                this.$t('profileEdit.Carian'),
                this.$t('profileEdit.Catalan'),
                this.$t('profileEdit.Kekchi'),
                this.$t('profileEdit.Celtiberian'),
                this.$t('profileEdit.Quechua'),
                this.$t('profileEdit.Chinese'),
                this.$t('profileEdit.Comanche'),
                this.$t('profileEdit.Coptic'),
                this.$t('profileEdit.Korean'),
                this.$t('profileEdit.Cornish'),
                this.$t('profileEdit.Cofán'),
                this.$t('profileEdit.Khmer'),
                this.$t('profileEdit.Ladin'),
                this.$t('profileEdit.Laz'),
                this.$t('profileEdit.Lezgian'),
                this.$t('profileEdit.Lebanese'),
                this.$t('profileEdit.Lithuanian'),
                this.$t('profileEdit.Macedonian'),
                this.$t('profileEdit.Maldivian'),
                this.$t('profileEdit.Mongolian'),
                this.$t('profileEdit.German'),
                this.$t('profileEdit.Dutch'),
                this.$t('profileEdit.Norwegian'),
                this.$t('profileEdit.Oromo'),
                this.$t('profileEdit.Persian'),
                this.$t('profileEdit.Polish'),
                this.$t('profileEdit.Portuguese'),
                this.$t('profileEdit.Romanian'),
                this.$t('profileEdit.Russian'),
                this.$t('profileEdit.Cebuano'),
                this.$t('profileEdit.Serbian'),
                this.$t('profileEdit.Sephardic'),
                this.$t('profileEdit.Syriac'),
                this.$t('profileEdit.Trukese'),
                this.$t('profileEdit.Turkish'),
                this.$t('profileEdit.Turkmen'),
                this.$t('profileEdit.WaAb'),
                this.$t('profileEdit.Udmurt'),
                this.$t('profileEdit.Uzbek'),
                this.$t('profileEdit.Ukrainian'),
                this.$t('profileEdit.UmeSami'),
                this.$t('profileEdit.Urdu'),
                this.$t('profileEdit.Finnish'),
                this.$t('profileEdit.French'),
                this.$t('profileEdit.Croatian'),
                this.$t('profileEdit.Zimbran'),
                this.$t('profileEdit.Chavacano'),
                this.$t('profileEdit.Chakma'),
                this.$t('profileEdit.Chamalins'),
                this.$t('profileEdit.Chamorro'),
                this.$t('profileEdit.Chamic'),
                this.$t('profileEdit.Chaha'),
                this.$t('profileEdit.Cheva'),
                this.$t('profileEdit.Chechen'),
                this.$t('profileEdit.Czech'),
                this.$t('profileEdit.Chickasaw'),
                this.$t('profileEdit.Chipewyan'),
                this.$t('profileEdit.Choctaw'),
                this.$t('profileEdit.Chuvash'),
                this.$t('profileEdit.Chukchi'),
                this.$t('profileEdit.Shoshone'),
                this.$t('profileEdit.Swedish'),
                this.$t('profileEdit.Alsatian'),
                this.$t('profileEdit.Estonian'),
                this.$t('profileEdit.Extremaduran'),
                this.$t('profileEdit.JamaicanPatois'),
                this.$t('profileEdit.Yao'),
                this.$t('profileEdit.Japanese'),
            ]
        };
    },

    computed: {
        ...mapGetters({
            user: "user/fetchUser",
            userErrors: "user/errors",
            isEmpty: "user/isEmpty",
        }),
        localUser: function () {
            if (Object.keys(this.tempUser).length) {
                return this.tempUser;
            }
            this.tempUser = Object.assign({}, this.user);
            return this.tempUser;
        },
    },
    created() {
        this.localizeValidation();
        for (let k in this.consts.languages) {
            this.languagesOptions.push(parseInt(k) + 1);
        }
    },
    methods: {
        beforeOpen(event) {
            this.checkScroll();
            this.tempUser = event.params.localUser;
        },
        beforeClose(event) {
            if (
                !this.isEmpty("user") &&
                (!this.tempUser.first_name ||
                    !this.tempUser.last_name ||
                    (this.tempUser.gender != 1 && this.tempUser.gender != 2) ||
                    !this.tempUser.birthday)
            ) {
                this.hasBugs = true;
                event.stop();
                document.body.classList.add("v--modal-block-scroll");
            } else {
                this.checkRemoveScroll();
            }
        },
        optionsConstructor(key) {
            let arr;

            arr = this.consts[key].map(function (e) {
                return e.value;
            });
            return arr;
        },

        costomGanderLabel(opt) {
            return this.gender[opt - 1].text;
        },
        customMonthLabel(opt) {
            return this.months[opt - 1];
        },
        customBirthdayLabel(opt) {
            return this.showbirthday[opt].text;
        },
        customEducationLabel(opt) {
            return this.education[opt].text;
        },
        customHeightLabel(opt) {
            return this.height[opt].text;
        },
        customWeightLabel(opt) {
            return this.weight[opt].text;
        },
        customBodytypeLabel(opt) {
            return this.body_type[opt].text;
        },
        customFamilyLabel(opt) {
            return this.family_status[opt].text;
        },
        customChildrenLabel(opt) {
            return this.amount_of_children[opt].text;
        },
        customAcquaintanceLabel(opt) {
            return this.acquaintance_goal[opt].text;
        },
        customSmokingLabel(opt) {
            return this.smoking[opt].text;
        },
        customAlcoholLabel(opt) {
            return this.alcohol[opt].text;
        },
        customLanguagesLabel(opt) {
            return this.languages[opt];
        },
        customShowBirthdayLabel(opt) {
            return this.show_birthday[opt].text;
        },
        customLabel(opt, label) {
            if (label == "weight") {
                if (opt == 0 || opt == "") {
                    return "Не выбрано";
                }
                return opt + " кг";
            }
            let text = "";
            let arr = this.consts[label].map(function (e) {
                if (e.value == opt) {
                    text = e.text;
                }
            });
            return text;
        },
        customMonthLabel(opt) {
            return this.consts.months[opt - 1];
        },
        next() {
            this.$validator.validateAll().then((valid) => {
                if (valid) {
                    this.$modal.hide("first-login-3");
                    this.$modal.show("first-login-4", { localUser: this.localUser });
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/components/_validation";
</style>

<style lang="scss">
@import "~@/assets/styles/layout/_first-login";

.error-modal {
    transition: box-shadow 1s;

    &.has-bugs {
        box-shadow: 0 24px 80px -2px rgba(255, 0, 0, 0.4) !important;
    }
}
</style>
